
import { defineComponent, inject, ref, watch } from "vue"
import dayjs from "dayjs"
import _ from "lodash"
import { shortcuts } from "@/helpers/date"

import { DataHook } from "../hooks"
import { Icon } from "@iconify/vue"

export default defineComponent({
	components: {
		Icon
	},
	props: {
		type: {
			type: [Boolean, String]
		},
		defaultDate: {
			type: Object
		}
	},
	setup({ type, defaultDate }) {
		const data = inject<DataHook>("data-hook")!
		const value = ref<string>("")
		const date =
			defaultDate ||
			ref<Date[]>([
				dayjs().set("hour", 0).set("minute", 0).set("second", 0).toDate(),
				dayjs()
					.add(1, "day")
					.set("hour", 0)
					.set("minute", 0)
					.set("second", 0)
					.toDate()
			])

		let timer: NodeJS.Timeout

		function search() {
			data.loading.value = true
			if (typeof timer === "number") clearTimeout(timer)
			timer = setTimeout(() => {
				data.search(value.value)
				data.loading.value = false
			}, 800)
		}

		function searchByDate() {
			data.searchByDate(date.value ?? [])
		}

		function searchByVisitDate() {
			data.searchByVisitDate(date.value ?? [])
		}

    function limitVisitDate(date: Date) {
      const target = dayjs(date)
      const start = dayjs()
          .subtract(30, "day")
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
      const end = dayjs().add(2, "year")
      // const currentSelectedDate = dayjs(model.visitDate).format("YYYY-MM-DD")
      // const today = dayjs().format("YYYY-MM-DD")
      // if (currentSelectedDate < today) {
      //   const start2 = dayjs()
      //       .subtract(1, "month")
      //       .set("hour", 0)
      //       .set("minute", 0)
      //       .set("second", 0)
      //   return target.isBefore(start2) || target.isAfter(end)
      // }
      return target.isBefore(start) || target.isAfter(end)
    }

		if (type === "column") {
			search()
		} else if (type === "date") {
			watch(date, searchByDate)
			searchByDate()
		} else {
			watch(date, searchByVisitDate)
		}

		return {
			value,
			date,
			shortcuts,
			search,
      limitVisitDate,
		}
	}
})
